/**
 * 用户相关接口
**/

// 发送验证码
export const sendSms = function (params) {
  return this.$http('post', '/api/sendSms', params)
}

// 登录
export const login = function (params) {
  return this.$http('post', '/api/account/login', params);
}

// 注册
export const register = function (params) {
  return this.$http('post', '/api/account/register', params)
}

// 忘记密码
export const lossPassword = function (params) {
  return this.$http('post', '/api/account/lossPassword', params)
}

// 人员详情
export const getAccountDetail = function (params) {
  return this.$http('get', '/api/account/detail', params)
}

// pc个人培训列表
export const getTrainDetailPage = function (params) {
  return this.$http('get', '/api/page', params)
}
// pc执裁记录
export const getJudgmentDetailPage = function (params) {
  return this.$http('get', '/judgment-detail/api/page', params)
}

// 编辑裁判员
export const updateReferee = function (params) {
  return this.$http('post', '/api/referee/update', params)
}
